<template>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
			
			<!-- Header -->
                <HeaderMain />
			<!-- /Header -->
			
			<!--Section Banner-->	
                <Banner />
			<!--/Section Banner-->	

			<!--Section Benefits-->	
                <Benefits />
			<!--/Section Benefits-->	

			<!--Section Top Schools-->	
                <!-- <TopSchools /> -->
			<!--/Section Top Schools-->	

			<!--Section Top Courses-->	
                <TopCourses />
			<!--/Section Top Courses-->	

			<!--Section Count-->	
                <Count />
			<!--/Section Count-->		

			<!--Section Top Instructors-->	
                <TopInstructors />
			<!--/Section Top Instructors-->	

			<!--Section Featured School-->	
                <!-- <FeaturedSchool /> -->
			<!--/Section Featured School-->	

			<!--Section Blog-->	
                <!-- <FeaturedBlog /> -->
			<!--/Section Blog-->	

			<!--Section Enrollment-->	
                <!-- <Enrollment /> -->
			<!--/Section Enrollment-->	

			<!--Section Review-->	
                <Reviews />
			<!--/Section Review-->	

			<!-- Footer -->
                <!-- <layout-footer /> -->
                <Footer/>
			<!-- /Footer -->
			
            
		</div>
		<!-- /Main Wrapper -->
</template>

<script>
import HeaderMain from '../Layout/HeaderMain'
import Footer from '../Layout/Footer'
import Banner from '../HomePage/Banner'
import Benefits from '../HomePage/Benefits'
import TopSchools from '../HomePage/TopSchools'
import TopCourses from '../HomePage/TopCourses'
import TopInstructors from '../HomePage/TopInstructors'
import Count from '../HomePage/Count'
import FeaturedSchool from '../HomePage/FeaturedSchool'
import FeaturedBlog from '../HomePage/FeaturedBlog'
import Enrollment from '../HomePage/Enrollment'
import Reviews from '../HomePage/Reviews'
import store from '../../store'

export default {
    components: {
		HeaderMain,
        Banner,
        Benefits,
        TopSchools,
        TopCourses,
        TopInstructors,
        Count,
        FeaturedSchool,
        FeaturedBlog,
        Enrollment,
        Reviews, Footer
    },
    created: function () {
        if(localStorage.getItem('token')){
            store.dispatch("checktoken");
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/HomePage/index.vue